// 风向热搜榜数据（匿名化叙事，聚焦粉丝反应而非个人指控）

export type WindCategory = "脱粉" | "回踩" | "后援会" | "超话" | "站姐";

export interface WindItem {
  id: number;
  cat: WindCategory;
  heat: number;
  time: string;
  title: string;
  excerpt: string;
  dir: "up" | "down" | "flat";
}

export const windFilters: { key: WindCategory | "全部"; label: string }[] = [
  { key: "全部", label: "全部风向" },
  { key: "脱粉", label: "脱粉" },
  { key: "回踩", label: "回踩" },
  { key: "后援会", label: "后援会" },
  { key: "超话", label: "超话" },
  { key: "站姐", label: "站姐" },
];

export const windItems: WindItem[] = [
  {
    id: 1,
    cat: "回踩",
    heat: 96,
    time: "09:42",
    title: "站姐公开多年应援账目，疑涉资金去向引来集体追讨",
    excerpt:
      "一份被晒出的账目明细显示应援款与公开物料存在出入，曾经的会员在评论区逐条核对，回踩声量迅速攀升。",
    dir: "up",
  },
  {
    id: 2,
    cat: "脱粉",
    heat: 92,
    time: "08:57",
    title: "一线男歌手被曝隐瞒恋情，粉丝 24 小时集中取关",
    excerpt:
      "从取关个人社交账号到移除超话粉丝牌，多名头部粉丝同日行动，数据粉圈开始出现明显的冷却迹象。",
    dir: "up",
  },
  {
    id: 3,
    cat: "超话",
    heat: 88,
    time: "08:21",
    title: "超话大主持深夜卸任，签名博瞬间被质问评论淹没",
    excerpt:
      "主持人在声明中称自身立场与多数粉丝分歧过大，卸任后相关超话出现签到下滑与广场内容翻转的双重压力。",
    dir: "up",
  },
  {
    id: 4,
    cat: "后援会",
    heat: 84,
    time: "昨日",
    title: "官方后援会声明一删再发，口径摇摆引发会员退会潮",
    excerpt:
      "声明从坚决支持改为保留立场又再删除，前后矛盾让基层会员质疑组织立场，退会与要求换届的呼声持续走高。",
    dir: "flat",
  },
  {
    id: 5,
    cat: "站姐",
    heat: 80,
    time: "昨日",
    title: "头部站子连夜清空单人物料，灰色头像暗示正式关站",
    excerpt:
      "此前活跃的应援账号在数小时内批量清空精修图与行程记录，多名粉丝前往评论区确认其去留，站姐动向成焦点。",
    dir: "down",
  },
  {
    id: 6,
    cat: "回踩",
    heat: 76,
    time: "昨日",
    title: "前粉丝万字长文复盘七年追星，登顶情感热议榜",
    excerpt:
      "文章从初见舞台写到处境崩塌，强调被辜负的信任而非单纯的恨，引发大量共鸣，成为回踩叙事的一种典型样本。",
    dir: "up",
  },
  {
    id: 7,
    cat: "超话",
    heat: 72,
    time: "本周",
    title: "塌房一周后超话签到跌破阈值，数据组紧急下调目标",
    excerpt:
      "连续多日签到与转评量下滑，相关数据组发布公告调整运营目标，被外界视作粉圈基础盘松动的信号。",
    dir: "down",
  },
  {
    id: 8,
    cat: "脱粉",
    heat: 68,
    time: "本周",
    title: "怀旧剧重播带动观众回流，路人盘回升成新话题",
    excerpt:
      "在情绪逐步平息后，作品本身开始接棒个人热度，部分观望用户以路人身份回流，形成脱粉之后的二次讨论。",
    dir: "up",
  },
  {
    id: 9,
    cat: "站姐",
    heat: 64,
    time: "本周",
    title: "考古向站子宣布转型，仅保留高光舞台剪辑",
    excerpt:
      "部分站姐选择以回忆向内容软性收尾，只保留舞台与作品切片，主动与近期负面拉开距离，被视为温和离场。",
    dir: "flat",
  },
];